import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack, Typography } from "@mui/material";
import { Formaters } from "lib/Formaters";
import React from "react";

interface IProps {
    icon: IconDefinition;
    value: number;
    valueDescription?: React.ReactNode;
    footer?: React.ReactNode[];
}

export const DashBoxResume: React.FC<IProps> = ({ icon, value, valueDescription, footer }) => {
    return (
        <Box>
            <Stack direction="row" justifyContent="center" alignItems="start" spacing={2} sx={{ mb: 1 }}>
                <div>
                    <Typography color="primary">
                        <FontAwesomeIcon icon={icon} size="3x" />
                    </Typography>
                </div>
                <div>
                    <Stack direction="column" alignItems="center" justifyContent="center" gap={2}>
                        <Typography component="div" fontSize={32} color="muted.main"><b>{Formaters.numberShortView(value)}</b></Typography>
                        <Stack direction="column" alignItems="center" justifyContent="center">
                            {
                                valueDescription &&
                                <Typography component="div" fontSize={14} color="muted.main" textTransform="uppercase"><b>{valueDescription}</b></Typography>
                            }
                            {
                                footer &&
                                <Stack direction="column" justifyContent="center" alignItems="center">
                                    {
                                        footer.map((line, index) => <Typography component="div" fontWeight="bold" fontSize={12} color="muted.main">{line}</Typography>)
                                    }
                                </Stack>
                            }
                        </Stack>
                    </Stack>
                </div>
            </Stack>
        </Box>
    );
};
